<template>
  <div class="suspension-protection">
    <div class="desc">
      <span class="title">{{ $t('suspensionProtection.title') }}</span>
      <span class="text" v-html="$t('suspensionProtection.text', {amount: $props.amount})"/>
    </div>
    <base-button size="small" @click="modalVisible = true">{{ $t('common.activate') }}</base-button>
    <confirmation-modal :visible="modalVisible"
                        confirm-type="empty"
                        :confirm-title="$t('suspensionProtection.modal.title')"
                        :dynamic-data-description="$t('suspensionProtection.modal.text', {amount: $props.amount})"
                        :confirm-text="$t('common.activate')"
                        cancel-button
                        :loading="confirmationLoader"
                        @close="modalVisible = false"
                        @confirm="activate"/>
  </div>
</template>

<script>
import ConfirmationModal from '@/components/common/modal/confirmation-modal'
import errorMessageHandler from '@/mixins/errorMessageHandler'

export default {
  name: 'suspension-protection',
  components: { ConfirmationModal },
  mixins: [errorMessageHandler],
  props: {
    subscriberIdentity: String,
    amount: String
  },

  data () {
    return {
      modalVisible: false,
      confirmationLoader: false
    }
  },

  methods: {
    activate () {
      this.confirmationLoader = true
      const data = {
        subscriberIdentity: this.$props.subscriberIdentity
      }
      this.$apiRequest.post('user/services/suspension', data).then(() => {
        this.$emit('refresh-data', this.$props.subscriberIdentity)
        this.toast('success', {
          title: this.$t('toastMessages.successToastTitle'),
          message: this.$t('suspensionProtection.protectionActivated')
        })
      }).catch(e => {
        this.handleErrorMessage(e.response.data)
      }).finally(() => {
        this.confirmationLoader = false
        this.modalVisible = false
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.suspension-protection {
  border-radius: .5rem;
  margin-bottom: 7rem;
  padding: 1.6rem;
  background: $white;

  @media (map_get($breakpoints, sm)) {
    display: flex;
  }

  .base-button {
    margin-top: 1.6rem;
    width: 100%;

    @media (map_get($breakpoints, sm)) {
      margin-top: 0;
      margin-left: 2.4rem;
      width: auto;
    }
  }
}

.desc {
  margin-right: auto;
  line-height: 1.2;
}

.title {
  display: block;
  margin-bottom: .2rem;
  font-weight: 600;
}

.text {
  font-size: 1.5rem;
}
</style>
